import { useState, useEffect } from "react";
import SteelpanScene from "./SteelpanScene";

export function ClientOnly({
  fallback,
}: {
  fallback: React.ReactNode;
  onStatus?: (message: string) => void;
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return <>{fallback}</>;
  return <SteelpanScene />;
}
